import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { routes } from "../gen/General";
import { do_login, do_mod } from "./actions";
import { Button, Card, CardBody, CardFooter, CardHeader } from "reactstrap";
import AES from "crypto-js/aes";
import enc from "crypto-js/enc-utf8";

import Alerts from "../util/Alerts";
import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom";
import { Field, Form, Formik, useFormikContext } from "formik";
import Footer from "../components/Footer/Footer";
import logo from "assets/img/prodeseg_login.png";
import usuario from "assets/img/usuario.png";
import contrasena from "assets/img/contrasena.png";
import * as Sentry from "@sentry/react";
import { redirectToCotizador } from "../util/General";

export const Login = () => {
    const [item, setItem] = useState({ enki: "", perseo: "" });
    const [loading, setLoading] = useState(true);
    const [showPass, setShowPass] = useState(false);
    const [stepPass, setStepPass] = useState(false);

    const alert = React.useRef(null);
    const dispatch = useDispatch();
    const searchParams = new URL(document.location).searchParams;
    const history = useHistory();
    const params = useParams();

    useEffect(() => {
        axios.defaults.withCredentials = true;
        checkLogin(params.hash);
        const mailcito = sessionStorage.getItem("mailcito");
        const param1 = searchParams.get("param1");
        const param2 = searchParams.get("param2");
        const encodedEmail = searchParams.get("email");
        if (encodedEmail) {
            const email = window.atob(encodedEmail);
            sessionStorage.setItem("mailcito", email);
            setItem({ enki: email, perseo: "" });
            history.push("");
            return;
        }
        if (param1 && param2) {
            const user = decodeB64(param1);
            const pass = decodeB64(param2);
            setItem({ ...item, enki: user, perseo: pass });
            setStepPass(true);
            return;
        }
        if (mailcito) {
            setItem({ ...item, enki: mailcito });
        }
    }, []);

    const decodeB64 = b64 => {
        return decodeURIComponent(window.atob(b64)) || "";
    };

    function checkLogin(hash) {
        let config = {};
        if (hash) {
            // pa saber q viene x la url del movil
            sessionStorage.setItem("uqai", true);
            let uqai = localStorage.getItem("uqai");
            if (uqai) {
                let uqai2 = decrypt(uqai);
                if (uqai2.enki) {
                    setItem(uqai2);
                }
            }
        }
        // compruebo si previamente ya incio sesion
        axios
            .post(routes.base + "/enki", {}, config)
            .then(resp => {
                if (resp.data.user && resp.data.user.id) {
                    let mod = sessionStorage.getItem("efi_mod");
                    if (mod) {
                        dispatch(do_mod(mod));
                    }
                    get_asociados(resp, hash);
                }
            })
            .catch(error => {
                setLoading(false);
                dispatch(do_login({ username: null, id: null }));
            });
    }

    const save_login = data => {
        if (params.hash) {
            localStorage.setItem("uqai", encrypt(data));
        }
    };

    const onLoginSucess = data => {
        dispatch(do_login(data));
    };

    const onRequestAuth = (newValues, { setSubmitting }) => {
        if (newValues?.enki) {
            sessionStorage.setItem("mailcito", newValues.enki);
        }
        if (!stepPass) {
            validateUser(newValues, setSubmitting);
            return;
        }
        const data = newValues;

        //headers q lee el spring security (efi-sec)
        let headers = { authorization: "Basic " + btoa(data.enki.trim().toLowerCase() + ":" + data.perseo.trim()) };

        // envio de peticion
        axios
            .post(routes.base + "/enki", {}, { headers: headers })
            .then(resp => {
                // hay respuesta exitosa desde el server, si se inicio sesión
                //lanzo accion con los datos del usuario
                get_asociados(resp);

                if (!resp.data.user.fcCambioClave) {
                    history.push("/perfil?iris=true");
                } else {
                    sessionStorage.setItem("firstTimeLogin", "true");
                    save_login(newValues);
                    redirectToCotizador();
                    if (params.hash) {
                        history.push("/");
                    }
                }
            })
            .catch(error => {
                setSubmitting(false);

                let msg = alert.current.handle_error(error);
                if (msg.indexOf("expirado") >= 0) {
                    history.push("/renovar/" + btoa(data.enki));
                }
                dispatch(do_login({ username: null, id: null }));
            });
    };

    function validateUser(newValues, setSubmitting) {
        axios
            .post(routes.base + "/public/crush-validate", newValues)
            .then(resp => {
                setSubmitting(false);
                if (resp.data.exist) {
                    setStepPass(true);
                } else {
                    history.push("/registro?existe=true");
                }
            })
            .catch(e => {
                setSubmitting(false);
            });
    }

    function get_asociados(resp, hash) {
        Promise.all([
            axios.post(routes.base + "/enki/asociados", { cdAdicional: resp.data.user.id }),
            axios.post(routes.apiVam + "/enki/asociados", { cdAdicional: resp.data.user.id }),
        ])
            .then(function (values) {
                setLoading(false);
                onLoginSucess({
                    ...resp.data.user,
                    asociados: values[0].data,
                    asociadosVam: values[1].data,
                    roles: resp.data.roles,
                });
                if (hash) {
                    history.push("/");
                }
            })
            .catch(err => {
                alert.current.handle_error(err);
            });
    }

    const toggle = () => {
        if (showPass) {
            // todo tiemout
        }
        setShowPass(!showPass);
    };

    return (
        <>
            <div className={"col-12 col-md-7 bg-green-blur"}>
                <div className="logo-wrp">
                    <img src={logo} alt="now-logo" />
                </div>
                <Formik onSubmit={onRequestAuth} initialValues={item} enableReinitialize={true}>
                    <FormularioLogin
                        stepPass={stepPass}
                        setStepPass={setStepPass}
                        showPass={showPass}
                        toggle={toggle}
                    />
                </Formik>
                <Footer fluid={true} />
            </div>
            <Alerts ref={alert} />
        </>
    );
};

const FormularioLogin = ({ stepPass, setStepPass, showPass, toggle }) => {
    const perseoRef = useRef(null);
    const { values, setFieldValue, isSubmitting, dirty } = useFormikContext();

    useEffect(() => {
        if (!dirty) return;
        setStepPass(false);
        setFieldValue("perseo", "");
    }, [values.enki]);

    useEffect(() => {
        if (!stepPass) return;
        perseoRef.current.focus();
    }, [stepPass]);

    return (
        <Form className={"d-flex justify-content-end flex-column align-items-center align-items-md-end"}>
            <Card className="card-login card-plain">
                <CardHeader>
                    <h3 className="mb-0 text-center text-white py-3">BIENVENIDO</h3>
                </CardHeader>
                <CardBody className={"py-0 text-center my-auto"}>
                    {!stepPass && (
                        <>
                            <div>
                                <span className="text-white">Ingresa tu correo electrónico</span>
                            </div>
                            <br />
                        </>
                    )}
                    <img className="img-fluid mb-1 text-white" src={usuario} alt="usr" />

                    <Field className="form-control" name="enki" type="text" placeholder="Usuario" />
                    {stepPass && (
                        <>
                            <div className={"mt-3"}>
                                <span className="text-white">Ingresa tu contraseña </span>
                            </div>
                            <img className="img-fluid my-2 text-white" src={contrasena} alt="pass" />

                            <div className={"show-pass"}>
                                <Field
                                    className="form-control"
                                    name="perseo"
                                    type={showPass ? "text" : "password"}
                                    placeholder="Contraseña"
                                    innerRef={perseoRef}
                                />
                                <i className={showPass ? "fas fa-eye" : "fas fa-eye-slash"} onClick={toggle} />
                            </div>
                        </>
                    )}
                </CardBody>
                <CardFooter className="pt-0 mt-3">
                    <Button
                        block
                        round
                        color="white"
                        size="lg"
                        className="mb-3 py-1 text-primary"
                        type={"submit"}
                        disabled={isSubmitting}
                    >
                        {stepPass ? "Ingresar" : "Siguiente"}
                    </Button>
                    {stepPass && (
                        <>
                            <div className="text-center">
                                <h6>
                                    <Link to="/recuperar" className="link footer-link">
                                        ¿Olvidó su Contraseña?
                                    </Link>
                                </h6>
                            </div>
                        </>
                    )}
                </CardFooter>
                <div className={"separator"} />
            </Card>
        </Form>
    );
};

function decrypt(data) {
    try {
        // Decrypt
        let bytes = AES.decrypt(data, get_secret());
        return JSON.parse(bytes.toString(enc));
    } catch (e) {
        sentry_error(e);
    }
}

function encrypt(data) {
    try {
        return AES.encrypt(JSON.stringify(data), get_secret()).toString();
    } catch (e) {
        sentry_error(e);
    }
    return null;
}

function get_secret() {
    return "xc2022";
}

function sentry_error(e) {
    Sentry.captureException(e, { tags: { login: true } });
}

function sentry_info(msg, obj) {
    if (obj) {
        Sentry.captureMessage(msg, { tags: { login: true, dt: JSON.stringify(obj) } });
    } else {
        Sentry.captureMessage(msg, { tags: { login: true } });
    }
}
